var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"talk-theme-view"},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s('お題: ' + _vm.text)+" ")]),_c('div',{},[_vm._v(" ※ 議論を開始してください。 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }